// extracted by mini-css-extract-plugin
module.exports = {"root":"paq-view_root__98KjU","container":"paq-view_container__f5hv5","content_container":"paq-view_content_container__7cc_F"};